import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmploymentContractType  {
    _originalTypeClassName = "zERP.BO.EmploymentContractType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmploymentContractType.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.ForPublicSector = false;
this.RelationshipType = null;
this.WorkingSchedule = null;
this.PeriodCalculation = null;
this.Category = null;
this.IsBreakInWorkingHours = false;
this.ActiveFrom = null;
this.PeriodDays = null;
this.WeekDays = null;
this.DayHours = null;
this.ContractDayHours = null;
this.WeekHours = null;
this.ContractWeekHours = null;
this.HasBreak = false;
this.BreakDuration = null;
this.Kind = null;
this.EasterBonusDays = null;
this.LeaveBonusDays = null;
this.ChristmasBonusDays = null;
this.BalanceBonusDays = null;
this.IsFixedBonusAmount = false;
this.MaxChristmasBonus = null;
this.MaxEasterBonus = null;
this.PrivateSectorBonusPaymentType = null;
this.NoBonus = false;
this.CompensationType = null;
this.TaxType = null;
this.IsIndependentTaxation = false;
this.TaxTypeMultiply = null;
this.WorkingScheduleStartTime = null;
this.WorkingScheduleEndTime = null;
this.BreakWindow = null;
this.ErganiDescription = null;
this.ChristmasBonusPeriodFrom = moment([2024, (5) - 1, 1]).toDate();
this.ChristmasBonusPeriodTo = moment([2024, (12) - 1, 31]).toDate();
this.EasterBonusPeriodFrom = moment([2024, (1) - 1, 1]).toDate();
this.EasterBonusPeriodTo = moment([2024, (4) - 1, 30]).toDate();
this.LeaveBonusPeriodFrom = moment([2024, (1) - 1, 1]).toDate();
this.LeaveBonusPeriodTo = moment([2024, (12) - 1, 31]).toDate();
this.WorkingDaysCalculationMethod = null;
this.FullTimePeriodDays = null;
this.FullTimeWeekDays = null;
this.FullTimeWeekHours = null;
this.BaseCalculationDays = null;
this.APDDailyWageEarner = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
ForPublicSector:any;
RelationshipType:any;
WorkingSchedule:any;
PeriodCalculation:any;
Category:any;
IsBreakInWorkingHours:any;
ActiveFrom:any;
PeriodDays:any;
WeekDays:any;
DayHours:any;
ContractDayHours:any;
WeekHours:any;
ContractWeekHours:any;
HasBreak:any;
BreakDuration:any;
Kind:any;
EasterBonusDays:any;
LeaveBonusDays:any;
ChristmasBonusDays:any;
BalanceBonusDays:any;
IsFixedBonusAmount:any;
MaxChristmasBonus:any;
MaxEasterBonus:any;
PrivateSectorBonusPaymentType:any;
NoBonus:any;
CompensationType:any;
TaxType:any;
IsIndependentTaxation:any;
TaxTypeMultiply:any;
WorkingScheduleStartTime:any;
WorkingScheduleEndTime:any;
BreakWindow:any;
ErganiDescription:any;
ChristmasBonusPeriodFrom:any;
ChristmasBonusPeriodTo:any;
EasterBonusPeriodFrom:any;
EasterBonusPeriodTo:any;
LeaveBonusPeriodFrom:any;
LeaveBonusPeriodTo:any;
WorkingDaysCalculationMethod:any;
FullTimePeriodDays:any;
FullTimeWeekDays:any;
FullTimeWeekHours:any;
BaseCalculationDays:any;
APDDailyWageEarner:any;
TaxTypeCalculatedExpression:any;
DaysConfiguration:any;
static setTaxTypeCalculatedExpression = ($this, value) => {
var oldValue = $this.TaxTypeCalculatedExpression;
$this.TaxTypeCalculatedExpression = value;
if (value != null) {
}
}
static setDaysConfiguration = ($this, value) => {
var oldValue = $this.DaysConfiguration;
$this.DaysConfiguration = value;
if (value != null) {
}
}

static GetActualHoursPerDay($this: any): any{let totalDays = 0.0;
let totalHours = 0.0;
for (var i = 0; CLMS.Framework.Number.LessThanOrEqual(() => i, () => 6); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let hours = Domain.ContractDaysConfiguration.WorkingHoursByDayNumber($this?.DaysConfiguration, i);if (CLMS.Framework.Number.Equal(() => hours, () => 0)) {continue;}totalDays = Joove.Common.safeNumber(totalDays) + Joove.Common.safeNumber(1);totalHours = Joove.Common.safeNumber(totalHours) + Joove.Common.safeNumber(hours);}

if (CLMS.Framework.Number.Equal(() => totalDays, () => 0)) {return 0;}
return Joove.Common.safeNumber(totalHours) / Joove.Common.safeNumber(totalDays);
}
static GetContractDayHours($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.WeekDays, () => null) || CLMS.Framework.Number.Equal(() => $this.WeekDays, () => 0)) {return 0;}
return Joove.Common.safeNumber($this?.WeekHours) / Joove.Common.safeNumber($this?.WeekDays);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}